import TextWidgetView from './TextWidgetView.vue';

export const type = 'text';
export const view = TextWidgetView;

export function builder() {
  return {
    type,
    text: 'סיפור מהתזרים שהלקוחות יאהבו',
    left: 0,
    top: 0,
    rotate: 0,
    height: 100,
    width: 350,
    textAlign: 'right',
    direction: 'rtl',
    verticalAlign: 'start',
    color: '#000000',
    background: '#FFFFFF',
    fontFamily: 'SimplerPro',
    fontSize: 20,
    borderRadius: 0,
    boxShadow: '',
    border: 'none',
    textShadow: 'none',
  };
}
